import { useFormikContext } from 'formik'
import React, { useRef } from 'react'
import { useTranslation } from 'react-i18next'

import { useNavigate } from '@lib/react-router-dom'

import { Button } from '@ui/components/Button'
import { ContentBlock } from '@ui/components/ContentBlock/ContentBlock'
import { FeatureIcon } from '@ui/components/FeatureIcon/FeatureIcon'
import { CircleCheckIcon } from '@ui/icons/CircleCheck.icon'

import { useFundingExit } from '@hooks/useFundingExit'

import { Box } from '@shared/components/Box'
import { FullScreenFooter } from '@shared/templates/FullScreenLayout'
import { FundingTemplate } from '@shared/templates/FundingTemplate'

import type { WithdrawalFormValues } from '../WithdrawalFlowLayout/types'

export const WithdrawalSuccessContent: React.FC = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const contentRef = useRef<HTMLDivElement>(null)
  const { values } = useFormikContext<WithdrawalFormValues>()
  const { handleExit } = useFundingExit()

  const onViewHistory = () => {
    if (values.dashboardContext === 'payment-agent') {
      navigate('/dashboard/payment-agent/transaction-history')
      return
    }
    if (values.dashboardContext === 'introducing-broker') {
      navigate('/dashboard/introducing-broker/reports/transactions-history')
      return
    }
    navigate('/dashboard/traders-room/transaction-history')
  }

  return (
    <FundingTemplate contentRef={contentRef} onExit={handleExit}>
      <Box flex direction='column' gap='x32' fullWidth align='center' minHeight='100%'>
        <ContentBlock
          variant='voucher'
          icon={
            <FeatureIcon
              size='lg'
              icon={CircleCheckIcon}
              bg='surface-success-high-em'
              color='text-white'
            />
          }
          title={t('Withdrawal Submitted')}
          description={t('Your withdrawal request has been received and is being processed.')}
        />

        <FullScreenFooter contentRef={contentRef}>
          <Button.Primary size='lg' fullWidth onClick={onViewHistory}>
            {t('View History')}
          </Button.Primary>
        </FullScreenFooter>
      </Box>
    </FundingTemplate>
  )
}
